import { render, staticRenderFns } from "./ResponsibilityAvailableInspectorsCards.vue?vue&type=template&id=32d3b300&scoped=true"
import script from "./ResponsibilityAvailableInspectorsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAvailableInspectorsCards.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityAvailableInspectorsCards.vue?vue&type=style&index=0&id=32d3b300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3b300",
  null
  
)

export default component.exports